import Typography from "@mui/material/Typography";
import { BarChart, BarChartProps } from "@mui/x-charts/BarChart";

const translations = {
  plusMinus: "+/- per Game",
  toi: "Time on Ice",
  plusMinusTotal: "+/- Total",
} as const;

function addLabels<T extends { dataKey: keyof typeof translations }>(
  series: T[],
) {
  return series.map((item) => ({
    ...item,
    label: translations[item.dataKey],
  }));
}

function transformTime(toiString: string): number {
  toiString = toiString || "0:00";
  const parts = toiString.split(":").map(Number);
  if (parts.length === 2) {
    const minutes = parts[0];
    const seconds = parts[1];
    return minutes + seconds / 60;
  }
  return 0;
}

export default function StackBarsTimePlusMinus({
  chartData,
}: {
  chartData: any;
}) {
  let i = 0;
  const filteredChartData = chartData?.map(({ plusMinus, toi }) => ({
    plusMinus: Number(plusMinus ?? 0),
    toi: transformTime(toi),
    game: ++i,
  }));

  const combinedChartData = [];
  let runningTotalplusMinus = 0;
  filteredChartData?.forEach((item) => {
    const totalplusMinus = item.plusMinus || 0;
    runningTotalplusMinus += totalplusMinus;
    combinedChartData.push({
      ...item,
      plusMinusTotal: runningTotalplusMinus,
    });
  });

  //    console.log(combinedChartData);

  return (
    <div style={{ width: "100%" }}>
      <Typography style={{ color: "black", fontWeight: "900" }}>
        Time on ice and +/-
      </Typography>
      <BarChart
        dataset={combinedChartData || []}
        xAxis={[{ dataKey: "game" }]}
        series={addLabels([
          { dataKey: "plusMinus", barWidth: 10 },
          { dataKey: "toi", barWidth: 10 },
          { dataKey: "plusMinusTotal", barWidth: 10 },
        ])}
        {...config}
      />
    </div>
  );
}

const config: Partial<BarChartProps> = {
  height: 350,
  margin: { left: 0 },
  yAxis: [{ width: 35 }],
  hideLegend: false,
};
